import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams, useLocation } from 'react-router-dom';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

const It_Check_List = () => {
  const [rejectedList, setRejectedList] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchRejectedData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}it_check_local`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await response.json();
        setRejectedList(result.data || []);
        setFilteredResults(result.data || []);
      } catch (error) {
        console.error('Error fetching rejected list:', error);
        setRejectedList([]);
        setFilteredResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRejectedData();
  }, [API_BASE_URL]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtered = rejectedList.filter(
      (item) =>
        item.emp_code?.toLowerCase().includes(value.toLowerCase()) ||
        item.comp_name?.toLowerCase().includes(value.toLowerCase()) ||
        item.trans_code?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredResults(filtered);
    setCurrentPage(1);
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredResults.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredResults.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
      <div className="wrapper">
        <Header />
        <Sidebar />

        <div className="content-wrapper p-3">
          <h3 className="mb-4 text-center">Pending Local conveyance List</h3>

          <div className="form-group mb-3 col-md-4 mx-auto">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Emp Code / Name / Trans Code..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>

          {loading ? (
            <p className="text-center">Loading...</p>
          ) : filteredResults.length === 0 ? (
            <p className="text-center">No rejected items found.</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th>Emp Code</th>
                      <th>Trans Code</th>
                      <th>Employee Name</th>
                      <th>Submitted</th>
                      <th>Grade</th>
                      <th>Department</th>
                      <th>Designation</th>
                      <th>Mobile</th>
                      <th>Bank Name</th>
                      <th>Bank A/C No</th>
                      <th>IFSC</th>
                      <th>Report Mngr</th>
                      <th>R. Mngr Status</th>
                      <th>Manager Remarks</th>
                      <th>Audit Manager</th>
                      <th>Audit Status</th>
                      <th>Audit Approved Amount</th>
                      <th>Accounts Manager</th>
                      <th>Accounts Status</th>
                      <th>Accounts Remarks</th>
                      <th>Location</th>
                      <th>Total KM</th>
                      <th>Total Conveyance</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item) => (
                      <tr key={item.id}>
                        <td>{item.emp_code}</td>
                        <td>{item.trans_code}</td>
                        <td>{item.comp_name}</td>
                        <td>{item.is_submitted}</td>
                        <td>{item.grade}</td>
                        <td>{item.dept_name}</td>
                        <td>{item.designation_name}</td>
                        <td>{item.mobile}</td>
                        <td>{item.bank_name}</td>
                        <td>{item.bank_acnum}</td>
                        <td>{item.ifsc_code}</td>
                        <td>{item.report_mngr}</td>
                        <td>{item.rpt_mgr_status}</td>
                        <td>{item.manager_remarks || '-'}</td>
                        <td>{item.audit_manager || '-'}</td>
                        <td>{item.audit_status}</td>
                        <td>{item.audit_approved_amount}</td>
                        <td>{item.accounts_manager || '-'}</td>
                        <td>{item.accounts_status}</td>
                        <td>{item.accounts_remarks || '-'}</td>
                        <td>{item.location_name}</td>
                        <td>{item.total_km}</td>
                        <td>{item.total_localconveyance}</td>
                        <td>{item.created_at}</td>
                         <td>
                                                                                                        <Link to={`/edit_rm_local_conveyance/${item.id}`}>
                                                                                                            <i className="fa fa-edit" style={{ fontSize: '12px', color: 'green', marginRight: '10px' }}></i>
                                                                                                        </Link>
                                                                                                        {/* {item.account_status === 'Pending' && (<a href="#" onClick={(e) => handleDelete(item.id, e)}>
                                                                                                                <i className="fa fa-times" style={{ fontSize: '12px', color: 'red' }}></i>
                                                                                                            </a>)} */}
                                                                                                    </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default It_Check_List;
